import { Component, Input } from '@angular/core';
import { ICardRoadSituationsModel } from '@types-custom/models/ui/card-road-situations-model';
import { DrawerPanelService } from '@ui-core/services/drawer-panel/drawer-panel.service';
import { BehaviorSubject } from 'rxjs';

/*
** Card Road Situations
** Render a modal that displays road situation information.
*/
@Component({
  selector: 'sit-card-road-situations',
  templateUrl: './card-road-situations.component.html',
  styleUrls: ['./card-road-situations.component.scss'],
})
export class CardRoadSituationsComponent {
  @Input() card: ICardRoadSituationsModel | undefined;

  constructor(private drawerPanelService: DrawerPanelService) {}

  openModal(): void {
    this.drawerPanelService.collapseDrawer(true);
    this.card?.cardMapLink?.markerDispatcher.next(
      this.card.cardMapLink.markerModel
    );
  }
}
